import { RightioWBSAPIModelsUdtUdtServiceAgreementAddress } from "@src/utilities/apis/wbs/model";
import { CCNewAPIDtoAddressDto, CCNewAPIDtoPropertyBuildingTypeEnum } from "../../../apis/ccm/model";

export class ServiceAgreementAddress implements RightioWBSAPIModelsUdtUdtServiceAgreementAddress {
  constructor() {
    this.#serviceAgreementAddressId = 0;
    this.#propertyBuildingTypeId = -1;
    this.#property = "";
    this.#organisation = "";
    this.#street = "";
    this.#locality = "";
    this.#town = "";
    this.#county = "";
    this.#postcode = "";
    this.#bathrooms = 0;
    this.#bedrooms = 0;
    this.#externalDoors = 0;
    this.#gasAppliances = 0;
    this.#radiators = 0;
    this.#comments = "";
  }

  #serviceAgreementAddressId: number;
  #propertyBuildingTypeId: number;
  #property: string
  #organisation: string;
  #street: string;
  #locality: string;
  #town: string;
  #county: string;
  #postcode: string;
  #bathrooms: number;
  #bedrooms: number;
  #externalDoors: number;
  #gasAppliances: number;
  #radiators: number;
  #comments: string;

  toObject(): any {
    return {
      _serviceAgreementAddressId: this.#serviceAgreementAddressId,
      _propertyBuildingTypeId: this.#propertyBuildingTypeId,
      _property: this.#property === "N/A"
        ? (this.#organisation || "")
        : this.#organisation
          ? `${this.#organisation}, ${this.#property}`
          : this.#property,
      _street: this.#street,
      _locality: this.#locality,
      _town: this.#town,
      _county: this.#county,
      _postcode: this.#postcode,
      _bathrooms: this.#bathrooms,
      _bedrooms: this.#bedrooms,
      _externalDoors: this.#externalDoors,
      _gasAppliances: this.#gasAppliances,
      _radiators: this.#radiators,
      _comments: this.#comments,
    };
  }

  toRequest(): CCNewAPIDtoAddressDto {
    return {
      propertyBuildingTypeId: this.#convertToEnum(this.#propertyBuildingTypeId),
      property: this.#property === "N/A"
        ? (this.#organisation || "")
        : this.#organisation
          ? `${this.#organisation}, ${this.#property}`
          : this.#property,
      street: this.#street,
      locality: this.#locality,
      town: this.#town,
      county: this.#county,
      postcode: this.#postcode,
      bathrooms: this.#bathrooms,
      bedrooms: this.#bedrooms,
      externalDoors: this.#externalDoors,
      gasAppliances: this.#gasAppliances,
      radiators: this.#radiators,
      comments: this.#comments,
    };
  }

  #convertToEnum = (value: number): CCNewAPIDtoPropertyBuildingTypeEnum => {
    switch (value) {
      case 1:
        return CCNewAPIDtoPropertyBuildingTypeEnum.detached;
      case 2:
        return CCNewAPIDtoPropertyBuildingTypeEnum.semi_detached;
      case 3:
        return CCNewAPIDtoPropertyBuildingTypeEnum.terraced;
      case 4:
        return CCNewAPIDtoPropertyBuildingTypeEnum.maisonette;
      case 5:
        return CCNewAPIDtoPropertyBuildingTypeEnum.flat;
      case 6:
        return CCNewAPIDtoPropertyBuildingTypeEnum.bungalow;
      default:
        return CCNewAPIDtoPropertyBuildingTypeEnum.detached;
    }
  };

  public get serviceAgreementAddressId(): number {
    return this.#serviceAgreementAddressId;
  }

  public set serviceAgreementAddressId(serviceAgreementAddressId: number) {
    this.#serviceAgreementAddressId = serviceAgreementAddressId;
  }

  public get propertyBuildingTypeId(): number {
    return this.#propertyBuildingTypeId;
  }

  public set propertyBuildingTypeId(propertyBuildingTypeId: number) {
    this.#propertyBuildingTypeId = propertyBuildingTypeId;
  }

  public get property(): string {
    return this.#property;
  }

  public set property(property: string) {
    this.#property = property;
  }

  public get organisation(): string {
    return this.#organisation;
  }

  public set organisation(organisation: string) {
    this.#organisation = organisation;
  }

  public get street(): string {
    return this.#street;
  }

  public set street(street: string) {
    this.#street = street;
  }
  public get locality(): string {
    return this.#locality;
  }

  public set locality(locality: string) {
    this.#locality = locality;
  }

  public get town(): string {
    return this.#town;
  }

  public set town(town: string) {
    this.#town = town;
  }

  public get county(): string {
    return this.#county;
  }

  public set county(county: string) {
    this.#county = county;
  }
  public get postcode(): string {
    return this.#postcode;
  }

  public set postcode(postcode: string) {
    this.#postcode = postcode;
  }

  public get bathrooms(): number {
    return this.#bathrooms;
  }

  public set bathrooms(bathrooms: number) {
    this.#bathrooms = bathrooms;
  }

  public get bedrooms(): number {
    return this.#bedrooms;
  }

  public set bedrooms(bedrooms: number) {
    this.#bedrooms = bedrooms;
  }

  public get externalDoors(): number {
    return this.#externalDoors;
  }

  public set externalDoors(externalDoors: number) {
    this.#externalDoors = externalDoors;
  }

  public get gasAppliances(): number {
    return this.#gasAppliances;
  }

  public set gasAppliances(gasAppliances: number) {
    this.#gasAppliances = gasAppliances;
  }

  public get radiators(): number {
    return this.#radiators;
  }

  public set radiators(radiators: number) {
    this.#radiators = radiators;
  }

  public get comments(): string {
    return this.#comments;
  }

  public set comments(comments: string) {
    this.#comments = comments;
  }
}
